module.exports = __webpack_public_path__ + "img/Mellat.046d56d9.svg";